module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "color": "red",
      "background-color": "#fff",
      "z-index": "9999"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.debugMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5af72c5c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/debug.vue
// module id = 23
// module chunks = 0